import { render, staticRenderFns } from "./Error401.vue?vue&type=template&id=20061908&scoped=true"
import script from "./Error401.vue?vue&type=script&lang=js"
export * from "./Error401.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20061908",
  null
  
)

export default component.exports